<template>
  <div>
    <div v-if="!dataLoaded">
      <b-card title="لیست حساب های بانکی" no-body>
        <b-card-body>
          <b-skeleton type="button" width="120px"></b-skeleton>
          <b-row>
            <div class="col-md-4">
              <b-card class="mt-4 pt-5 pb-5" no-body>
                <b-row>
                  <b-col cols="4">
                    <b-skeleton width="100px" height="100px"></b-skeleton>
                  </b-col>
                  <b-col>
                    <div class="data">
                      <b-skeleton width="80px"></b-skeleton>
                      <p class="text-bold">
                        <b-skeleton width="90%"></b-skeleton>
                      </p>
                    </div>

                    <b-skeleton type="button"></b-skeleton>
                  </b-col>
                </b-row>
              </b-card>
            </div>
            <div class="col-md-4">
              <b-card class="mt-4 pt-5 pb-5" no-body>
                <b-row>
                  <b-col cols="4">
                    <b-skeleton width="100px" height="100px"></b-skeleton>
                  </b-col>
                  <b-col>
                    <div class="data">
                      <b-skeleton width="80px"></b-skeleton>
                      <p class="text-bold">
                        <b-skeleton width="90%"></b-skeleton>
                      </p>
                    </div>

                    <b-skeleton type="button"></b-skeleton>
                  </b-col>
                </b-row>
              </b-card>
            </div>
            <div class="col-md-4">
              <b-card class="mt-4 pt-5 pb-5" no-body>
                <b-row>
                  <b-col cols="4">
                    <b-skeleton width="100px" height="100px"></b-skeleton>
                  </b-col>
                  <b-col>
                    <div class="data">
                      <b-skeleton width="80px"></b-skeleton>
                      <p class="text-bold">
                        <b-skeleton width="90%"></b-skeleton>
                      </p>
                    </div>

                    <b-skeleton type="button"></b-skeleton>
                  </b-col>
                </b-row>
              </b-card>
            </div>
            <div class="col-md-4">
              <b-card class="mt-4 pt-5 pb-5" no-body>
                <b-row>
                  <b-col cols="4">
                    <b-skeleton width="100px" height="100px"></b-skeleton>
                  </b-col>
                  <b-col>
                    <div class="data">
                      <b-skeleton width="80px"></b-skeleton>
                      <p class="text-bold">
                        <b-skeleton width="90%"></b-skeleton>
                      </p>
                    </div>

                    <b-skeleton type="button"></b-skeleton>
                  </b-col>
                </b-row>
              </b-card>
            </div>
            <div class="col-md-4">
              <b-card class="mt-4 pt-5 pb-5" no-body>
                <b-row>
                  <b-col cols="4">
                    <b-skeleton width="100px" height="100px"></b-skeleton>
                  </b-col>
                  <b-col>
                    <div class="data">
                      <b-skeleton width="80px"></b-skeleton>
                      <p class="text-bold">
                        <b-skeleton width="90%"></b-skeleton>
                      </p>
                    </div>

                    <b-skeleton type="button"></b-skeleton>
                  </b-col>
                </b-row>
              </b-card>
            </div>
            <div class="col-md-4">
              <b-card class="mt-4 pt-5 pb-5" no-body>
                <b-row>
                  <b-col cols="4">
                    <b-skeleton width="100px" height="100px"></b-skeleton>
                  </b-col>
                  <b-col>
                    <div class="data">
                      <b-skeleton width="80px"></b-skeleton>
                      <p class="text-bold">
                        <b-skeleton width="90%"></b-skeleton>
                      </p>
                    </div>

                    <b-skeleton type="button"></b-skeleton>
                  </b-col>
                </b-row>
              </b-card>
            </div>
          </b-row>
        </b-card-body>
      </b-card>
    </div>
    <div v-if="dataLoaded">
      <b-card title="لیست حساب های بانکی" no-body>
        <b-card-body>
          <b-button class="mb-3" variant="success" @click="showAddNewCard"
            >اضافه کردن حساب بانکی</b-button
          >
        </b-card-body>
        <b-card-text>
          <AddCard
            v-bind:afterdone="getCardList"
            v-bind:cardId="cardId"
            v-bind:canceled="AddCardCanceled"
          ></AddCard>
          <b-tabs card>
            <b-tab title="حساب های من" active>
              <b-row>
                <div class="col-md-4" v-for="card in MycardList" :key="card.id">
                  <b-card
                    :class="isDeactived(card)"
                    class="mt-4 pt-5 pb-5"
                    no-body
                  >
                    <b-row>
                      <b-col cols="4">
                        <b-img
                          :src="
                            '/media/BankImage/' +
                            card.bank_name.latin_code +
                            '-300-c.png'
                          "
                          fluid
                        ></b-img>
                      </b-col>
                      <b-col>
                        <div class="data">
                          <p class="text-bold">
                            {{ card.nickname }}
                          </p>
                        </div>
                        <div class="data">
                          شماره شبا
                          <p class="text-bold" style="word-spacing: 4px">
                            {{ card.shaba_number.match(/.{1,4}/g).join("  ") }}
                          </p>
                        </div>
                        <div class="data">
                          شماره حساب
                          <p class="text-bold">
                            {{ card.account_number }}
                          </p>
                        </div>

                        <b-button
                          hidden
                          size="sm"
                          v-on:click="editBankingCard(card)"
                          variant="outline-success"
                          >ویرایش حساب</b-button
                        >
                      </b-col>
                    </b-row>
                  </b-card>
                </div>
              </b-row>
            </b-tab>
            <b-tab title="حساب های شرکای تجاری">
              <b-card-text>
                <b-row>
                  <div
                    class="col-md-4"
                    v-for="card in OtherCardList"
                    :key="card.id"
                  >
                    <b-card
                      :class="isDeactived(card)"
                      class="mt-4 pt-5 pb-5"
                      no-body
                    >
                      <b-row>
                        <b-col cols="4">
                          <b-img
                            :src="
                              '/media/BankImage/' +
                              card.bank_name.latin_code +
                              '-300-c.png'
                            "
                            fluid
                          ></b-img>
                        </b-col>
                        <b-col>
                          <div class="data">
                            <p class="text-bold">
                              {{ card.nickname }}
                            </p>
                          </div>
                          <div class="data">
                            شماره شبا
                            <p class="text-bold" style="word-spacing: 4px">
                              {{
                                card.shaba_number.match(/.{1,4}/g).join("  ")
                              }}
                            </p>
                          </div>
                          <div class="data">
                            شماره حساب
                            <p class="text-bold">
                              {{ card.account_number }}
                            </p>
                          </div>

                          <b-button
                            hidden
                            size="sm"
                            v-on:click="editBankingCard(card)"
                            variant="outline-success"
                            >ویرایش حساب</b-button
                          >
                        </b-col>
                      </b-row>
                    </b-card>
                  </div>
                </b-row>
              </b-card-text>
            </b-tab>
          </b-tabs>
        </b-card-text>
      </b-card>
    </div>
  </div>
</template>
<style scoped>
.grayscale img,
.grayscale .data {
  filter: grayscale(1);
  opacity: 0.5;
}
.grayscale button {
  filter: none;
}
</style>
<script>
import httpHelper from "../../helpers/httpHelper";
import MDDropdown from "../../components/MDDropdown";
import AddCard from "./AddCard";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "cardList",
  components: { MDDropdown, AddCard },
  data: function () {
    return {
      dataLoaded: false,
      error: [],
      MycardList: [],
      cardModalTitle: "افزودن کارت بانکی",
      cardId: null,
      cardAliasName: null,
      cardBankName: null,
      card_number: null,
      accountNumber: null,
      ibanNumber: null,
      cardExpireYear: null,
      cardExpireMonth: null,
      isInEditMode: false,
      cardId: null,
      OtherCardList: [],
    };
  },
  methods: {
    isDeactived(card) {
      return card.is_enable == 1 ? "" : "grayscale";
    },
    AddCardCanceled() {
      this.cardId = null;
    },
    onChange(event) {
      console.log(event);
    },
    getCardList: function () {
      httpHelper.setAuth();
      httpHelper
        .getData("usercards")
        .then((response) => {
          this.MycardList = response.result.filter(function (o) {
            return o.is_business_partners == 0;
          });
          this.OtherCardList = response.result.filter(function (o) {
            return o.is_business_partners == 1;
          });
          this.dataLoaded = true;
        })
        .finally(() => {});
    },
    showAddNewCard: function () {
      this.isInEditMode = false;
      this.cardId = null;
      this.showCardModal();
    },
    showCardModal: function () {
      this.$bvModal.show("addcard-modal");
    },
    hideAddCardModal: function () {
      this.$refs["addcard-modal"].hide();
    },
    sendAddOrEditCardRequest: function () {
      httpHelper.setAuth();
      let cardData = {
        nickname: this.cardAliasName,
        card_number: this.card_number,
        shaba_number: this.ibanNumber,
        expire_month: this.cardExpireMonth,
        expire_year: this.cardExpireYear,
        mdid13_bank_name: this.cardBankName,
        account_number: this.accountNumber,
      };
      if (this.isInEditMode) cardData.id = this.cardId;

      httpHelper
        .postData("usercards", cardData)
        .then((response) => {
          if (response.success === true) {
            this.getCardList();
            this.hideAddCardModal();
          } else {
            this.error = [];
            for (var key in response.error) {
              response.error[key].forEach((element) => {
                this.error.push(element);
              });
            }
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    editBankingCard: function (card) {
      this.cardId = null;
      this.showCardModal();
      this.cardId = card.id;
    },
    showEdit: (card) => {
      console.log(card.id);
    },
  },
  created() {
    this.getCardList();
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "حساب های بانکی" }]);
  },
};
</script>